import filterMenuItems, { filterCloudMenuItems } from "util/conditional/filterMenuItems";
import { IlluminateDotBadge } from "common/components";
import { DATA_LAKE_INTERNAL_ENABLED } from "data-lake/Constants";
import Permissions from "security-app/Permissions";
import useLicenseCheck from "license/useLicenseCheck";
import Routes from "routing/Routes";
import SecurityRoutes from "security-app/routing/Routes";
import DEFAULT_ENTERPRISE_NAV_ITEM from "components/navigation/DefaultEnterpriseNavItem";
import { DEFAULT_SECURITY_NAV_ITEM } from "components/security/bindings";
import { COLLECTIONS_ENABLED, COLLECTIONS_ROUTE } from "collections/constants";
import EnterpriseRoutes from "./EnterpriseRoutes";
const SECURITY_MENU_ITEMS = [
  {
    path: SecurityRoutes.THREAT_COVERAGE,
    description: "Threat Coverage",
    permissions: Permissions.securityApp.read,
    end: true
  },
  { path: Routes.SECURITY.ACTIVITY, description: "Activity", permissions: Permissions.securityApp.read },
  {
    path: SecurityRoutes.INVESTIGATIONS.LIST,
    description: "Investigations",
    permissions: ["investigations:read", "streams:read:datastream:gl-security-investigations-metrics"]
  },
  { path: Routes.SECURITY.ANOMALIES, description: "Anomalies", permissions: "anomaly_configuration:read" },
  { path: SecurityRoutes.SIGMA.LIST, description: "Sigma Rules", permissions: Permissions.securityApp.read },
  { path: SecurityRoutes.ASSETS.list("machine"), description: "Assets", permissions: "asset:read" }
];
const ENTERPRISE_AND_CLOUD_ROUTES = [
  { path: EnterpriseRoutes.OVERVIEW, description: "Overview", permissions: "licenseinfos:read" },
  { path: EnterpriseRoutes.ARCHIVES, description: "Archives", permissions: "archive:read" },
  { path: EnterpriseRoutes.AUDIT_LOG, description: "Audit Log", permissions: "auditlog_status:read" },
  { path: EnterpriseRoutes.LICENSES, description: "Licenses", permissions: "licenses:read" },
  { path: EnterpriseRoutes.REPORTS, description: "Reports" },
  { path: EnterpriseRoutes.CUSTOMIZATION, description: "Customization", permissions: "clusterconfig:read" },
  { path: EnterpriseRoutes.FORWARDERS, description: "Forwarders", permissions: "forwarders:edit" },
  {
    path: EnterpriseRoutes.ILLUMINATE,
    description: "Illuminate",
    permissions: "illuminate_bundle_management:read",
    BadgeComponent: IlluminateDotBadge
  },
  { path: EnterpriseRoutes.MY_SEARCH_FILTERS, description: "My Search Filters" }
];
const bindings = {
  navigation: [
    {
      description: DEFAULT_ENTERPRISE_NAV_ITEM.description,
      position: DEFAULT_ENTERPRISE_NAV_ITEM.position,
      children: filterCloudMenuItems(
        filterMenuItems(
          COLLECTIONS_ENABLED ? [...ENTERPRISE_AND_CLOUD_ROUTES, COLLECTIONS_ROUTE] : ENTERPRISE_AND_CLOUD_ROUTES,
          DATA_LAKE_INTERNAL_ENABLED ? [] : [EnterpriseRoutes.DATA_LAKE]
        ),
        [EnterpriseRoutes.LICENSES, EnterpriseRoutes.FORWARDERS]
      ),
      BadgeComponent: IlluminateDotBadge
    },
    {
      description: DEFAULT_SECURITY_NAV_ITEM.description,
      position: DEFAULT_SECURITY_NAV_ITEM.position,
      children: SECURITY_MENU_ITEMS,
      useCondition: () => {
        const {
          security: { isValid: isValidSecurityLicense }
        } = useLicenseCheck();
        return isValidSecurityLicense;
      }
    }
  ]
};
export default bindings;
